/** API route map: URLS.Controller.ClientGuestNotes */
export const ClientGuestNotes = {
      Name: 'ClientGuestNotes/',
      GetAllGuestNote: 'get-all-guest-note',
      AddGuestNote: 'add-guest-note',
      update: 'update',
      delete: 'delete',
};
